import { setOptions } from '@googlemaps/js-api-loader';
import { readViteEnv } from './readViteEnv';

let configured = false;

export function googleMapsApiKey(): string {
  return readViteEnv('VITE_GOOGLE_MAPS_API_KEY') ?? '';
}

/** Advanced markers and vector tilt/rotate need a Map ID; DEMO keeps dev usable. */
export function googleMapsMapId(): string {
  return readViteEnv('VITE_GOOGLE_MAPS_MAP_ID') || 'DEMO_MAP_ID';
}

/**
 * The loader accepts options once per page, so every employer map surface has to
 * agree on the channel. `beta` is the lowest channel that ships the `maps3d`
 * library behind the employer 3D building view.
 */
export function configureGoogleMapsLoader(): boolean {
  const key = googleMapsApiKey();
  if (!key) return false;
  if (configured) return true;

  const authPolicy = readViteEnv('VITE_GOOGLE_MAPS_AUTH_REFERRER_POLICY') ?? '';
  setOptions({
    key,
    v: 'beta',
    ...(authPolicy ? { authReferrerPolicy: authPolicy } : {}),
  });
  configured = true;
  return true;
}

/** Escape hatch for the rare case an operator wants the full Google Maps app. */
export function googleMapsPlaceUrl(point: { lat: number; lng: number }): string {
  return `https://www.google.com/maps/search/?api=1&query=${point.lat},${point.lng}`;
}
